var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "calendar-scroll-footer",
      attrs: { "data-component": "calendar-scroll-footer" },
    },
    [
      _c("div", { staticClass: "calendar-scroll-footer-top" }, [
        _c("div", { staticClass: "calendar-scroll-footer-left" }, [
          _c("div", { staticClass: "price-range" }, [
            _c("span", { staticClass: "price-range-title" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.numberOfNights) +
                  " " +
                  _vm._s(_vm.tc("booking.startingAt")) +
                  "\n        "
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "toggle-group", attrs: { role: "tablist" } },
              _vm._l(_vm.priceRanges, function (range) {
                return _c(
                  "button",
                  {
                    key: range,
                    class: [{ selected: range === _vm.priceRange }],
                    attrs: {
                      id: range + "-range",
                      role: "tab",
                      "aria-selected": range === _vm.priceRange,
                      "aria-label": _vm.getRangeAriaLabel(range),
                      tabindex: range === _vm.priceRange ? "0" : "-1",
                    },
                    on: {
                      click: function ($event) {
                        _vm.priceRange = range
                      },
                      focus: _vm.bindKeyboardEvent,
                      blur: _vm.unbindKeyboardEvent,
                    },
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.tc("booking." + range)) +
                        "\n          "
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "price-section" }, [
            _c(
              "span",
              {
                staticClass: "price-value",
                style: [
                  {
                    opacity: _vm.haveClosedDaySelected(_vm.localQuery)
                      ? 0.4
                      : undefined,
                  },
                ],
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.getDisplayPrice({
                        price: _vm.finalPrice,
                        fromCurrency: _vm.hotelCurrency,
                        toCurrency: _vm.orSelected(_vm.hotelCurrency),
                        withIsoCode: _vm.showIsoCode,
                      })
                    ) +
                    "\n          "
                ),
                _c(
                  "div",
                  { staticClass: "currency-selector-wrapper" },
                  [
                    _c("currency-switcher", {
                      attrs: {
                        "base-currency": _vm.hotelCurrency,
                        "show-back-btn": true,
                      },
                      on: {
                        close: function ($event) {
                          return _vm.$emit("currency-switcher-closed")
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (ref) {
                            var activate = ref.activate
                            return _c(
                              "button",
                              {
                                staticClass: "currency-selector-button",
                                attrs: { "aria-label": "Select Currency" },
                                on: {
                                  click: activate,
                                  keydown: function ($event) {
                                    if (
                                      !$event.type.indexOf("key") &&
                                      _vm._k(
                                        $event.keyCode,
                                        "space",
                                        32,
                                        $event.key,
                                        [" ", "Spacebar"]
                                      )
                                    ) {
                                      return null
                                    }
                                    $event.preventDefault()
                                    return activate($event)
                                  },
                                },
                              },
                              [
                                _c("i", {
                                  staticClass:
                                    "icon-arrow-up-and-down currency-selector-icon",
                                  attrs: { "aria-hidden": "true" },
                                }),
                              ]
                            )
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "price-label",
                attrs: { "aria-describedby": "taxes-details" },
              },
              [
                _vm._v(
                  "\n          " + _vm._s(_vm.finalPriceLabel) + "\n        "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "special-code-add",
                class: { "special-code-add_selected": _vm.havePromoValues },
                on: {
                  click: function ($event) {
                    _vm.havePromoValues
                      ? _vm.removeEspecialCode()
                      : _vm.$emit("open-special-code")
                  },
                },
              },
              [
                _vm.havePromoValues
                  ? [
                      _vm._v(
                        "\n            " +
                          _vm._s(_vm.promoValue) +
                          "\n            "
                      ),
                      _c("div", { staticClass: "icon-close" }),
                    ]
                  : [
                      _c("div", { staticClass: "icon-plus" }),
                      _vm._v(" "),
                      _c("span", { staticClass: "code-text" }, [
                        _vm._v(
                          _vm._s(_vm.tc("booking.add")) +
                            " " +
                            _vm._s(_vm.tc("booking.specialCode"))
                        ),
                      ]),
                    ],
              ],
              2
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "calendar-scroll-footer-right" }, [
          _c("div", { staticClass: "calendar-scroll-footer-right-cta" }, [
            _c(
              "button",
              {
                class: [{ loading: _vm.isLoading }],
                attrs: {
                  disabled: _vm.isDisabled,
                  "aria-describedby": "taxes-details",
                },
                on: { click: _vm.submit },
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.tc("booking.confirm")) +
                    "\n          "
                ),
                _c(
                  "div",
                  { staticClass: "sr-only", attrs: { role: "status" } },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.isLoading
                            ? _vm.tc("accessibility.loadingButtonStatus")
                            : ""
                        ) +
                        "\n          "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "taxes-details", attrs: { id: "taxes-details" } },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.tc("booking.taxesDetails")) +
                    "\n        "
                ),
              ]
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }